export class LoyaltySdkError extends Error {
    constructor(message) {
        super(message);
        Object.setPrototypeOf(this, LoyaltySdkError.prototype);
    }
}
export class ConfigNotLoadedError extends LoyaltySdkError {
    constructor() {
        super("Config not loaded, initialize first");
        this.name = "ConfigNotLoadedError";
        Object.setPrototypeOf(this, ConfigNotLoadedError.prototype);
    }
}
export class LoyaltyNotSupportedError extends LoyaltySdkError {
    constructor() {
        super("Loyalty programme not supported in this country");
        this.name = "LoyaltyNotSupportedError";
        Object.setPrototypeOf(this, LoyaltyNotSupportedError.prototype);
    }
}
export class TierNotFoundError extends LoyaltySdkError {
    constructor(tierId) {
        super(`Tier ${tierId} not found`);
        this.name = "TierNotFoundError";
        Object.setPrototypeOf(this, TierNotFoundError.prototype);
    }
}
export class BenefitNotFoundError extends LoyaltySdkError {
    constructor(benefitType) {
        super(`Benefit ${benefitType} not found`);
        this.name = "BenefitNotFoundError";
        Object.setPrototypeOf(this, BenefitNotFoundError.prototype);
    }
}
